import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", {
  class: "h6 visually-hidden",
  role: "banner"
}, "Sportello Online - UNIGE", -1)
const _hoisted_2 = { class: "dimmable" }
const _hoisted_3 = { class: "container mt-2" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" | ")

import AuthenticableHeader from "@/layouts/common/AuthenticableHeader.vue";
import {Sprite, SpriteLD } from "cdp-fe-commons-layout";
import Footer from "@/layouts/common/Footer.vue"
import LoadingPage from "@/components/general/LoadingPage.vue";
import Notification from "@/components/general/Notification.vue";
import { EVENTS, subscribeEvent } from "@/emitter_mitt";
import CustomModal from "@/components/general/CustomModal.vue";
import { ref, Ref, watch,computed,shallowRef } from "vue";
import { IModal } from "@/interfaces/components/general/IModal";
import { ModalDimension } from "@/enums/components/general/ModalDimension";
import { ICustomComponent } from "@/interfaces/components/common/ICustomComponent";
import SetEmail from "@/components/user/SetEmail.vue";
import { useUserStore } from "@/stores/user";
import {useRoute} from "vue-router";
import {setLocale} from "@/i18n";
import { useServiceDetailStore } from "@/stores/service/serviceDetail";



export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const serviceDetailStore = useServiceDetailStore();
const currentLocale = ref(localStorage.getItem("locale") || "en");

function changeLocale(locale: string) {
  setLocale(locale);
  serviceDetailStore.setLanguage(locale);
  currentLocale.value = locale;
  localStorage.setItem("locale", locale); // Persist choice
}


const version: string = process.env.VUE_APP_VERSION;
const versionShow: boolean = process.env.VUE_APP_SHOW_VERSION === "true";

const userStore = useUserStore();

const modal: Ref<IModal> = shallowRef<IModal>({
  title: "Imposta email per notifiche",
  titleEn: "Set up email for notifications",
  closable: false,
  dimension: ModalDimension.MEDIUM,
  content: {
    render: SetEmail,
    events: {
      close: openCloseModal
    }
  } as ICustomComponent
} as IModal);

subscribeEvent(EVENTS.SET_EMAIL, openCloseModal);

watch(() => modal.value.show, () => {
  if (!modal.value.show)
    userStore.isAuthenticated();
});

const route = useRoute()
const skipLink = ref()

watch(
    () => route.path,
    () => {
      skipLink.value.focus()
    }
)

function openCloseModal() {
  modal.value.show = !modal.value.show;
  console.log('modal.value.show 2',modal.value.show)
}


// Check if the current route should have the header/footer
const showHeaderFooter = computed(() => {
  return route.meta.layout !== "no-layout"; // If layout is 'no-layout', hide header/footer
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("a", {
      class: "skip-to-content",
      ref_key: "skipLink",
      ref: skipLink,
      href: "#main"
    }, _toDisplayString(_ctx.$t('content')), 513),
    _createVNode(_unref(Sprite)),
    _createVNode(_unref(SpriteLD)),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(LoadingPage),
      (_unref(showHeaderFooter))
        ? (_openBlock(), _createBlock(AuthenticableHeader, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (changeLocale('it'))),
          style: _normalizeStyle({ fontWeight: currentLocale.value === 'it' ? 'bold' : 'normal', cursor: 'pointer'  })
        }, "IT", 4),
        _hoisted_4,
        _createElementVNode("span", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (changeLocale('en'))),
          style: _normalizeStyle({ fontWeight: currentLocale.value === 'en' ? 'bold' : 'normal', cursor: 'pointer'  })
        }, "EN", 4)
      ]),
      _createVNode(_component_router_view, { id: "main" }),
      (_unref(showHeaderFooter))
        ? (_openBlock(), _createBlock(Footer, {
            key: 1,
            id: "footer",
            version: _unref(version),
            "show-version": versionShow
          }, null, 8, ["version"]))
        : _createCommentVNode("", true),
      _createVNode(Notification),
      _createVNode(CustomModal, { modal: _unref(modal) }, null, 8, ["modal"])
    ])
  ], 64))
}
}

})